var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from "react";
import { addOrder, createOrder } from "@/05-models/order";
import { useErrorNotify } from "@/06-shared/lib/errorNotifier";
import { PopupButton, PopupInput, PopupWindow } from "@/06-shared/ui/popups";
import styles from "./index.module.css";
export const CreateOrder = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [bookId, setBookId] = useState("");
    const showError = useErrorNotify();
    const submit = () => __awaiter(void 0, void 0, void 0, function* () {
        const id = Number(bookId);
        if (!Number.isInteger(id) || id <= 0) {
            showError("ID книги должен быть положительным целым числом");
            return;
        }
        try {
            const order = yield createOrder(id);
            addOrder(order);
            setBookId("");
            setIsOpen(false);
        }
        catch (error) {
            showError(error);
        }
    });
    return (_jsxs(_Fragment, { children: [_jsx("button", { className: styles.openButton, onClick: () => setIsOpen(true), children: "[+]" }), isOpen && (_jsxs(PopupWindow, { name: "\u041D\u043E\u0432\u0430\u044F \u0437\u0430\u044F\u0432\u043A\u0430", onClose: () => setIsOpen(false), children: [_jsx(PopupInput, { name: "ID \u043A\u043D\u0438\u0433\u0438", value: bookId, setInput: setBookId, onEnter: submit, autoFocus: true }), _jsx(PopupButton, { name: "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C", onClick: submit })] }))] }));
};
